import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { setStayOnLanding } from '../../config/sessionKeys';
import PublicTopBar, { PublicFooter } from './PublicTopBar';
import './PublicV2.css';

/**
 * The sign-in frame in the new design (?ui=v2). The steps inside it —
 * WorkspaceLogin and TenantLogin — are today's components with today's
 * logic; PublicV2.css restyles their `lg-*` markup under `.pub2-auth`.
 * The brand panel has its own v2 copy (v1 keeps today's); it steps aside
 * on narrow screens, as today's does.
 */
export default function LoginShellV2({ children }) {
    const navigate = useNavigate();
    return (
        <div className="pub2 pub2-auth">
            <PublicTopBar />
            <main className="pub2-auth-main">
                <section className="pub2-auth-intro" aria-label="About IronSight">
                    <span className="pub2-eyebrow">Used-equipment intelligence</span>
                    <p className="pub2-auth-h">Your lot, priced and ranked every morning.</p>
                    <p className="pub2-auth-p">Each used unit gets an AI price estimate with a likely range, a days-to-sell forecast and its true carrying cost, right next to market comps and buyer interest.</p>
                    <dl className="pub2-facts">
                        <div><dt>Re-scored</dt><dd>every night</dd></div>
                        <div><dt>A price range</dt><dd>not just one number</dd></div>
                        <div><dt>Comps and interest</dt><dd>in the same view</dd></div>
                    </dl>
                </section>
                <div className="pub2-auth-card">
                    {/* A quiet way back to the landing page (QA L-10). The state makes
                        PublicRoutes skip the resume-to-sign-in redirect; sessionStorage keeps
                        that for the visit, so reloads and in-page links stay too (L-13). */}
                    <a className="pub2-back" href="/" onClick={(e) => { e.preventDefault(); setStayOnLanding(); navigate('/', { state: { stayOnLanding: true } }); }}>← Back to IronSight</a>
                    {children}
                </div>
            </main>
            <PublicFooter />
        </div>
    );
}
LoginShellV2.propTypes = { children: PropTypes.node };
